export var error = function (message) {
  function E() {
    this.message = message;
  }

  E.prototype = new Error();
  E.prototype.name = 'InvalidCharacterError';
  E.prototype.code = 5;
  return E;
};
export var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';


//////////////////
// WEBPACK FOOTER
// ./node_modules/b2a/es/common.js
// module id = 850
// module chunks = 0